import { IEnumAllLang } from '../../../types/lang'
import { offerScopeStatusLang } from './offerScopeStatus'
import { offerScopeCapTypeLang } from './offerScopeCapType'
import { datePickerModeLang } from './datePickerMode'
import { historyIsEmptyLang } from './historyIsEmpty'
import { postbackCurrencyLang } from './postbackCurrency'
import { postbackStatusLang } from './postbackStatus'
import { revenueAgencyFakeTypeLang } from './revenueAgencyFakeType'
import { accountIsActiveLang } from './accountIsActive'
import { roleExtraIsBuyerLang } from './roleExtraIsBuyer'
import { roleIsSystemLang } from './roleIsSystem'
import { roleAccessIsAnyLang } from './roleAccessIsAny'
import { offerSpendByAccountViewLang } from './offerSpendByAccountView'
import { offerSpendByOfferViewLang } from './offerSpendByOfferView'
import { offerSpendByOfferScopeViewLang } from './offerSpendByOfferScopeView'
import { percentIsEmptyLang } from './percentIsEmpty'
import { accountIsFiredLang } from './accountIsFired'


export const enumAllLang: IEnumAllLang = {
	...offerScopeStatusLang,
	...offerScopeCapTypeLang,
	...datePickerModeLang,
	...historyIsEmptyLang,
	...percentIsEmptyLang,
	...postbackCurrencyLang,
	...postbackStatusLang,
	...revenueAgencyFakeTypeLang,
	...accountIsActiveLang,
	...accountIsFiredLang,
	...roleExtraIsBuyerLang,
	...roleIsSystemLang,
	...roleAccessIsAnyLang,
	...offerSpendByAccountViewLang,
	...offerSpendByOfferViewLang,
	...offerSpendByOfferScopeViewLang
}